import Layout from "../components/layout";
import {
  ArrowBack,
  ArrowForwardNormal,
  RoadMap1,
  RoadMap2,
  RoadMap3,
  RoadMap4,
  RoadMap5,
  RoadmapBanner,
  ScrollTo,
} from "../shared/icons";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { screenSizes } from "../styles/theme";
import { useRef } from "react";

const RoadmapWrapper = styled.div`
  padding: 2rem 4rem;
  @media (max-width: ${screenSizes.M}px) {
    padding: 0rem 1rem;
  }
  ul {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    @media (max-width: ${screenSizes.M}px) {
      display: block;
    }
    > li {
      padding: 30px;
      border: 1px solid #091c001a;
      position: relative;
      height: calc(100% - 20px);
      margin-bottom: 70px;
      @media (max-width: ${screenSizes.M}px) {
        padding: 25px;
      }
      a {
        position: absolute;
        bottom: 35px;
        color: #091c00;
        transform: 0.3s;
        font-weight: 700;
        &:hover {
          color: #ff9d59;
          .svg-hover {
            filter: invert(75%) sepia(60%) saturate(487%) hue-rotate(-10deg)
              brightness(100%) contrast(92%);
          }
        }
        img {
          vertical-align: middle;
          margin-left: 10px;
        }
      }
      h3 {
        font-weight: 700;
        margin-top: 20px;
        @media (max-width: ${screenSizes.M}px) {
          margin-top: 10px;
          font-size: 24px;
        }
      }
      p {
        font-size: 18px;
        color: #091c00b2;
        line-height: 30px;
        min-height: 220px;
        @media (max-width: ${screenSizes.M}px) {
          line-height: 24px;
          font-size: 16px;
          min-height: auto;
          margin-bottom: 25px;
        }
        ul {
          list-style: disc;
          padding-left: 1.5rem;
          display: block;
          li {
            padding: 0;
            border: none;
            margin-bottom: 0;
            background: transparent !important;
            color: #091c00b2 !important;
          }
        }
      }
      &:nth-child(-n + 2) {
        background: #ff9d59;
        color: #fff;
        border-radius: 0 0px 0px 30px;
        img {
          margin-inline: auto;
          display: flex;
          margin-block: 5px;
        }
        p {
          color: #fff;
          ul li {
            color: #fff;
          }
        }
      }
    }
  }
`;

const RoadmapTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #091c001a;
  padding-bottom: 20px;
  margin-bottom: 30px;
  font-weight: 700;
  @media (max-width: ${screenSizes.L}px) {
    margin-bottom: 20px;
    margin-top: 25px;
  }
  h5 {
    font-size: 18px;
    margin: 0;
    color: #091c00;
    img {
      vertical-align: middle;
      margin-left: 15px;
      height: 16px;
      width: 16px;
    }
  }
`;

const HeroSection = styled.section`
  background: url(${RoadmapBanner}) no-repeat center center;
  background-size: cover;
  padding: 20px 60px;
  height: 720px;
  width: 100%;
  margin-top: 65px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: ${screenSizes.L}px) {
    height: 250px;
    padding: 1rem;
    margin-top: 60px;
  }
`;

const BackButton = styled.button`
  background: none;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #091c00;
  cursor: pointer;
  position: absolute;
  top: 20px;
  left: 4%;
  @media (max-width: ${screenSizes.L}px) {
    top: 10px;
    left: 2%;
  }
`;

const ScrollWrapper = styled.div`
  img {
    height: 64px;
    width: 64px;
    @media (max-width: ${screenSizes.L}px) {
      height: 24px;
      width: 24px;
    }
    &:hover {
      transform: scale(1.1);
      cursor: pointer;
    }
  }
`;

const IconWrapper = styled.span`
  margin-right: 10px;
  display: flex;
  align-items: center;
  svg {
    width: 14px;
    height: 14px;
  }
`;
const RoadmapImg1 = styled.span`
  background-color: #091c00;
  height: 80px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  font-size: 32px;
  font-style: italic;
  font-weight: 600;
  color: #fff;
  @media (max-width: ${screenSizes.L}px) {
    height: 64px;
    width: 64px;
  }
`;

const RoadmapImg3 = styled.span`
  background-color: #ff9d59;
  height: 80px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  font-size: 32px;
  font-style: italic;
  color: #fff;
  font-weight: 600;
  @media (max-width: ${screenSizes.L}px) {
    height: 64px;
    width: 64px;
  }
`;

const IconSeparator = styled.div`
  display: flex;
  justify-content: center;
  color: #091c00;
`;

const Roadmap = () => {
  const divRef = useRef<HTMLUListElement | null>(null);
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 1024;

  const handleScroll = () => {
    if (divRef.current) {
      const offset = 80;
      const elementPosition =
        divRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
    }
  };

  return (
    <Layout fullScreen>
      <HeroSection>
        {!isMobile && <BackButton onClick={() => navigate(-1)}>
          <IconWrapper>
            <ArrowBack />
          </IconWrapper>
          Back
        </BackButton>}
        <ScrollWrapper onClick={handleScroll}>
          <img src={ScrollTo} height={"64"} width={"64"} alt="scoll-to"/>
        </ScrollWrapper>
      </HeroSection>

      <RoadmapWrapper>
        <RoadmapTitle>
          <h5>
            Our Roadmap
            <img src={ArrowForwardNormal} alt="arrow forward"/>
          </h5>
          {!isMobile && <h5>About VYGA</h5>}
        </RoadmapTitle>
        <ul ref={divRef}>
          <li style={{ backgroundColor: "#E0772D" }}>
            <RoadmapImg1>1</RoadmapImg1>
            <h3>
              Status Quo:
              <br />
              Vision & Foundation
            </h3>
            <p>
              Develop and launch the AI Cross-Chain 
              Search to identify ESG-related digital 
              assets Q3 2024/Q1 2025 supported by The 
              Hashgraph Association (THA). Acceptance 
              into “Impact Collective Responsible 
              Finance” of leading think tank Phineo.
            </p>
            <img src={RoadMap1} alt="roadmap1"/>
            <div style={{ marginBlock: "42px" }}></div>
            <img src={RoadMap2} alt="roadmap2"/>
          </li>
          <li style={{ backgroundColor: "#FF9D59" }}>
            <RoadmapImg1>2</RoadmapImg1>
            <h3>
              Now & Next:
              <br />
              Impact Activation
            </h3>
            <p>
              Joint project with the European Integration 
              Group (EIG) x Google.org AI Opportunity 
              Fund initiated by BCG Foundation “Center 
              for Public Impact” to upskill blue-collar 
              workers, leveraging AI for greater impact in 2025
            </p>
            <img src={RoadMap3} alt="roadmap3"/>
            <br />
            <IconSeparator>X</IconSeparator>
            <img src={RoadMap4} alt="roadmap4"/>
            <br />
            <IconSeparator>X</IconSeparator>
            <img src={RoadMap5} alt="roadmap5"/>
          </li>
          <li style={{ backgroundColor: "transparent" }}>
            <RoadmapImg3>3</RoadmapImg3>
            <h3>
              Beyond:
              <br />
              Scale & Legacy
            </h3>
            <p style={{marginBottom: isMobile ? "55px" : '0'}}>
            Create an institutional-grade AI-driven multi-variable investment ranking system, leveraging W2, W3, and W4 to drive insights, transparency and efficient governance.
            {isMobile && <><br/><br/></>}
              <ul>
                <li>
                  Launch ​and scale further AI-driven pilot projects ​and initiatives focused on infrastructure, creative transformation and workforce productivity and expansion.
                </li>
                <li>
                  Integration of decentralized AI and IoT to generate real-time and hyper-local data for dynamic insights for faster monitoring, effective management and data-based governance.
                </li>
                <li>
                  Lead global AI-driven governance initiatives driving long-term productivity and broad-based development for a new era of growth.
                </li>
              </ul>
            </p>
            <a href="mailto:contact@vyga.co">
              Join Forces{" "}
              <img
                className="svg-hover"
                src={ArrowForwardNormal}
                alt="arrow forward"
              />
            </a>
          </li>
        </ul>
      </RoadmapWrapper>
    </Layout>
  );
};

export default Roadmap;
